import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {FabricService} from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-component-resources';


@Injectable({
  providedIn: 'root'
})
export class ComponentsService {

  constructor(private fabricService: FabricService) { }

  getComponents(componentType?): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_components_mgmt_components', {componentType});
  }

  postComponents(componentsForm): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_components_mgmt_components', componentsForm);
  }

  putComponents(componentsForm): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_components_mgmt_components_name_version', componentsForm);
  }

  deleteComponent(name, version): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'delete_components_mgmt_components_name_version', {name, version});
  }
}
